import React from 'react'
import Subscriber from 'components/subscriber/subscriber.component'
import useStyles from './subscriber-container.style'

const SubscriberContainer = () => {
  const classes = useStyles()
  return (
    <div className={classes.container}>
      <Subscriber />
    </div>
  )
}

export default SubscriberContainer
